<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="2">
        <v-select
          :items="query_targets"
          v-model="query_target"
          item-text="text"
          item-value="ref"
          solo dense></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Busca"
          solo
          v-model="query"
          @click:append="search()"
          append-icon="mdi-magnify"
          v-on:keyup.enter="search()"
          dense></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ counter }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn color="secondary" @click="compels()" block><v-icon>mdi-connection</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>CPF/CNPJ</th>
          <th>Telefone</th>
          <th>Celular</th>
          <th>E-mail</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.register }}</td>
          <td>{{ item.telephone }}</td>
          <td>{{ item.cellphone }}</td>
          <td>{{ item.email }}</td>
          <td><v-btn icon :to="'/client/' + item.id"><v-icon>mdi-magnify</v-icon></v-btn></td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: [],
    counter: 0,
    query: "",
    query_target: "name",
    query_targets: [
      {ref: "name", text: "Nome"},
      {ref: "cnpx", text: "CPF/CNPJ"},
      {ref: "telephone", text: "Telefone"},
      {ref: "cellphone", text: "Celular"},
      {ref: "email", text: "E-mail"},
      {ref: "address", text: "Endereço"}
    ],
    dialog_loading: false
  }),
  created: function() {
    this.count();
  },
  methods: {
    count: function() {
      var me = this;
      me.current = [];
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/client/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.counter = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    view: function(id) {
      router.push({ path: `/client/${id}` });
    },
    details: function(item) {
      router.push({ path: `/client/${item.id}` });
    },
    register: function (){
      router.push({path: "/client/new"});
    },
    compels: function (){
      router.push({path: "/client/compels"});
    },
    search: function() {
      var me = this;
      if(me.query==""){
        this.count();
        return;
      }
      if(me.query.length<3){
        alert("A busca precisa ter pelo menos 3 caracteres!");
        return;
      }
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/client/"+this.query_target+"/"+this.query, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.counter = me.current.length;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao realizar busca!");
        });
    }
  }
};
</script>